/*********************** Custom JS for Boost AI Search & Discovery  ************************/
function getProductMetafield(productData, namespace, key) {
    if (productData.hasOwnProperty('metafields')) {
        var metafieldValue = productData['metafields'].filter(function(e) {
            return e.namespace == namespace && e.key == key;
        });
        if (typeof metafieldValue[0] !== 'undefined') {
            return metafieldValue[0]['value'];
        }
    }
    return null; //Return null if metafield does not exist
};

function handleImageError(image) {
    image.style.display = 'none';
    image.parentNode.nextElementSibling.style.display = 'block';
}
// Filter API before call - Only works on collection
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
    registry.useModulePlugin('FilterAPI', {
        name: 'Filter API before call',
        apply(builder) {
            builder.on('beforeMethodCall', 'get', (payload) => {
                // Custom code goes here
                // Example
                payload.args[0].currency = boostSDAppConfig?.shop?.currency || Shopify.currency.active;
                payload.args[0].currency_rate = Shopify.currency.rate;
                payload.args[0].country = Shopify.country;
                payload.args[0].return_all_currency_fields = false;
                // End example
            });
        },
    });
});
function formatPrice(priceText) {
    return parseFloat(priceText.replace(/[^\d.,-]/g, '').replace(',', '.'));
}
let formatMoneyHelper = '';
const vatRates = {
                    'SEK': 25,
                    // Sverige
                    'NOK': 25,
                    // Norge
                    'EUR-DE': 19,
                    // Tyskland
                    'EUR-IT': 22,
                    // Italien
                    'USD': 0,
                    // USA (ingen moms)
                    'EUR-FI': 24,
                    // Finland
                    'DKK': 25,
                    // Danmark
                };
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FormatCurrency', {
            name: 'Show Trailing Zeros',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        formatMoneyHelper = element.getHelpers().formatMoney;
                        if (!formatMoneyHelper) return;
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
        /* Start-Boost-230831 */
        componentRegistry.useComponentPlugin("ProductItem", {
            name: "Component ProductItem",
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        let productData = element.getParams().props.product;
                        let productId = productData.id;
                        if (productData?.split_product) {
                            productId = productData.variant_id;
                        }
                        let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                        if (productItem) {
                            // Query price element
                            var itemPriceEl = productItem.querySelector('.boost-sd__product-price');
                            console.log('Price Element:', itemPriceEl);
                            let vendorLink = (Shopify?.routes?.root || '/') + 'collections/vendors?q=' + productData.vendor;
                            let vendorHtml = '';
                            vendorHtml += '<div class="boost-sd__custom-vendor">';
                            vendorHtml += '<a href="' + vendorLink + '" title="' + productData.vendor + '">';
                            vendorHtml += '<img src="' + getProductMetafield(productData, 'custom', 'vendorlogo') + '" alt="' + productData.vendor + '" onerror="handleImageError(this);" />';
                            vendorHtml += '</a>';
                            vendorHtml += '<p class="alt-text">';
                            vendorHtml += '<a href="' + vendorLink + '" title="' + productData.vendor + '">' + productData.vendor + '</a>';
                            vendorHtml += '</p>';
                            vendorHtml += '</div>';
                            console.log(productData.title, vendorHtml);
                            if (vendorHtml !== '' && productItem.querySelector('.boost-sd__product-item-grid-view-layout-image') && !productItem.querySelector('.boost-sd__custom-vendor')) {
                                productItem.querySelector('.boost-sd__product-item-grid-view-layout-image').insertAdjacentHTML('afterend', vendorHtml);
                            }
                            // Inventory stock status
                            let total_stock = 0;
                            for (let i = 0; i < productData.variants.length; i++) {
                                const variant = productData.variants[i];
                                if (variant?.inventory_management == 'shopify') {
                                    total_stock += variant.inventory_quantity;
                                }
                            }
                            let stockStatusHtml = '';
                            if (!productData.available) {
                                stockStatusHtml += '<div class="inventory-info">';
                                stockStatusHtml += '<span style="height: 10px; width: 10px; border-radius: 50%; display: inline-block; margin-right: 5px;"></span>';
                                stockStatusHtml += '<p style="padding: 5px; display: inline-block; color: #000000;">Denna produkt är för närvarande slut i lager.</p>';
                                stockStatusHtml += '</div>';
                            } else {
                                if (total_stock > 5) {
                                    stockStatusHtml += '<div class="inventory-info">';
                                    stockStatusHtml += '<span style="height: 10px; width: 10px; background-color: #5FAD56; border-radius: 50%; display: inline-block; margin-right: 5px;"></span>';
                                    stockStatusHtml += '<p style="padding: 5px; display: inline-block; color: #000000;">I lager (' + total_stock + ')</p>';
                                    stockStatusHtml += '</div>';
                                } else if (total_stock > 0) {
                                    stockStatusHtml += '<div class="inventory-info">';
                                    stockStatusHtml += '<span style="height: 10px; width: 10px; background-color: #FAA300; border-radius: 50%; display: inline-block; margin-right: 5px;"></span>';
                                    stockStatusHtml += '<p style="padding: 5px; display: inline-block; color: #000000;">Bara (' + total_stock + ')</p>';
                                } else {
                                    stockStatusHtml += '<div class="inventory-info">';
                                    stockStatusHtml += '<span style="height: 10px; width: 10px; background-color: #424874; border-radius: 50%; display: inline-block; margin-right: 5px;"></span>';
                                    stockStatusHtml += '<p style="padding: 5px; display: inline-block; color: #000000;">Beställningsvara</p>';
                                    stockStatusHtml += '</div>';
                                }
                            }
                            if (stockStatusHtml !== '' && productItem.querySelector('.boost-sd__inventory-status') && !productItem.querySelector('.badge-stock')) {
                                productItem.querySelector('.boost-sd__inventory-status').innerHTML = stockStatusHtml;
                            }
                            // Add custom attribute for price to support custom code in this file snippets/remlagret-vat.liquid
                            let normalPriceEl = productItem.querySelector('.boost-sd__format-currency:not(.boost-sd__format-currency--price-compare) > span');
                            let comparePriceEl = productItem.querySelector('.boost-sd__format-currency.boost-sd__format-currency--price-compare > span');

                            const countryDropdown = document.getElementById('country-dropdown');
                            const selectedCountry = countryDropdown.value;
                            let currency = selectedCountry.split('-')[0];
                            const currentRate = vatRates[currency];
                            if (currency === 'SEK') {
                                currency = 'Kr';
                            }
                            if (normalPriceEl !== null) {
                                normalPriceEl.classList.add('price');
                                normalPriceEl.setAttribute('data-original-price', productData.price_min);
                                // New price
                                if (localStorage.getItem('vat_type') == 'foretag') {
                                    // const newPrice = formatMoneyHelper((parseFloat(productData.price_min / 100) / 1.25), window.boostSDAppConfig?.shop?.money_format_with_currency, false);
                                    const newPrice = formatPrice((parseFloat(productData.price_min) / (1 + currentRate / 100)).toFixed(2)).toFixed(2);
                                    normalPriceEl.innerHTML = newPrice + ' ' + currency + ' <span class="new-vat-exclude-text">exkl. moms</span>';
                                } else {
                                    let newPrice;
                                    if (selectedCountry.split('-')[0] === 'SEK') {
                                      newPrice = formatPrice((parseFloat(productData.price_min)).toFixed(0)).toFixed(0);
                                      console.log(newPrice);
                                    } else {
                                      newPrice = formatPrice((parseFloat(productData.price_min)).toFixed(2)).toFixed(2);
                                    }                                    
                                    
                                    normalPriceEl.innerHTML = newPrice + ' ' + currency;
                                }
                            }
                            if (comparePriceEl !== null) {
                                comparePriceEl.classList.add('price');
                                comparePriceEl.setAttribute('data-original-price', productData.compare_at_price_min);
                                // New price
                                // if (localStorage.getItem('vat_type') == 'foretag') {
                                //     const newComparePrice = formatMoneyHelper((parseFloat(productData.compare_at_price_min) / 1.25).toFixed(2));
                                //     comparePriceEl.innerHTML = newComparePrice + ' <span class="new-vat-exclude-text">exkl. moms</span>';
                                // }
                            }

                            if (!productItem.querySelector('.boost-sd__integration-product-rating')) {
                              const rating = `<div class="boost-sd__integration-product-rating boost-sd__integration-product-rating--left"></div>`;
                                productItem.querySelector('.boost-sd__product-price').insertAdjacentHTML('afterend', rating);
                            }

                            if (!productItem.querySelector('.boost-sd__product-meta-subtitle')) {
                                const meta = productData.metafields.find(e => e.namespace == 'descriptors' && e.key == 'subtitle');
                                console.log(meta);
                                let metaHtml = `<div class="boost-sd__product-meta-subtitle"></div>`;
                                if (meta) {
                                    metaHtml = `<div class="boost-sd__product-meta-subtitle">${meta.value}</div>`;
                                }
                                productItem.querySelector('.boost-sd__product-title').insertAdjacentHTML('afterend', metaHtml);
                            }
                        }
                    } catch (error) {
                        console.warn(error);
                    }
                },
            }),
        });
    }
]);
// Additional logic for iterating over product items
/*
var productItems = document.querySelectorAll('.boost-sd__product-list .boost-sd__product-item');
productItems.forEach(function(item){
   console.log(item);
   var itemPriceEl = item.querySelector('.boost-sd__product-price');
   console.log(itemPriceEl);
});
*/
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FilterOption', {
            name: 'FilterOption - Customize sorting #232515',
            apply: () => ({
                props: (props) => {
                    if (props.option?.sortType == "key-asc") {
                        props.customizeSorting = (values) => {
                            // change logic sorting
                            let newValues = values.map(e => {
                                e.new_key = e.key.replace(/^\D+/g, '');
                                return e;
                            })
                            return values.sort((a, b) => a.new_key - b.new_key);
                        }
                    }
                    return props;
                },
            }),
        });
    }
]);